// src/pages/Login/LoginPage.jsx
import {
  Box,
  Button,
  CircularProgress,
  Grid2,
  Paper,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import "./LoginPage.css";
import { Form, Formik } from "formik";
import FormikTextField from "../../components/form/FormikTextField";
import logo from "../../assets/images/newlogo-primary.png";
import makeInIndia from "../../images/makeInIndia.svg";
import LoginBgPng from "../../assets/images/login-bg.png";
import useLogin from "../../hooks/useLogin";
import { Toaster } from "react-hot-toast";

const LoginPage = () => {
  const theme = useTheme();
  const isDark = localStorage.getItem("theme") === "dark";

  const {
    requestOtp,
    isOtpVisible,
    initialValues,
    validationSchema,
    isOtpLoading,
    onSubmit,
  } = useLogin();

  return (
    <Box
      style={{
        overflow: "hidden",
        height: "100vh",
        background: `url(${LoginBgPng})`,
        backgrondSize: "contain",
      }}
    >
      {/* Login-only toaster for OTP messages */}
      <Toaster
        toasterId="login"
        position="top-center"
        toastOptions={{
          duration: 2000,
          success: {
            style: {
              background: "#10b981",
              color: "#fff",
              border: "1px solid #059669",
            },
            iconTheme: {
              primary: "#fff",
              secondary: "#10b981",
            },
          },
          error: {
            style: {
              background: "#ef4444",
              color: "#fff",
              border: "1px solid #dc2626",
            },
            iconTheme: {
              primary: "#fff",
              secondary: "#ef4444",
            },
          },
        }}
      />

      <Paper
        sx={{
          px: 3,
          py: 4,
          height: "100%",
          width: { sm: "100%", md: "380px" },
          ml: "auto",
          borderRadius: 0,
          position: "relative",
        }}
        elevation={2}
      >
        {/* Header */}
        <Box display={"flex"} alignItems={"center"} mb={4} gap={1}>
          <img
            src={logo}
            alt="Logo"
            style={{
              width: "32px",
              height: "32px",
              filter: isDark
                ? "invert(81%) sepia(55%) saturate(553%) hue-rotate(1deg) brightness(101%) contrast(101%)"
                : "none",
            }}
          />
          <Stack>
            <Typography
              fontSize={14}
              color="text.primary"
              sx={{ fontWeight: 500 }}
            >
              Zerox Cloud
            </Typography>
            <Typography fontSize={10} color="text.secondary">
              Print Smarter, not Harder
            </Typography>
          </Stack>
        </Box>

        <Typography fontSize={24} color="text.primary" sx={{ fontWeight: 500 }}>
          Login
        </Typography>
        <Typography
          fontSize={16}
          className="Login-texts"
          color="text.secondary"
          sx={{ marginBottom: 4 }}
        >
          For Admin to manage services.
        </Typography>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ handleSubmit, values, isSubmitting }) => (
            <Form onSubmit={handleSubmit}>
              <Stack className="login-form" sx={{ width: "100%" }}>
                <Grid2 container spacing={2}>
                  {/* Mobile Number */}
                  <Grid2
                    size={{ xs: 12, md: 12 }}
                    sx={{ display: "flex", gap: 2, alignItems: "center" }}
                  >
                    <FormikTextField
                      startAdornment={"+91"}
                      name="mobile_number"
                      label="Mobile Number"
                      type="tel"
                      fullWidth
                      placeholder="Enter Mobile Number Here"
                      disabled={isSubmitting}
                    />
                    <Button
                      size="small"
                      variant="outlined"
                      sx={{ px: 2, whiteSpace: "nowrap", flexShrink: 0 }}
                      onClick={() => requestOtp(values.mobile_number)}
                      disabled={
                        isOtpLoading ||
                        values.mobile_number.length !== 10 ||
                        isSubmitting
                      }
                    >
                      {isOtpLoading ? "Sending..." : "Send OTP"}
                    </Button>
                  </Grid2>

                  {/* OTP Field */}
                  {isOtpVisible && (
                    <Grid2 size={{ xs: 12, md: 10 }}>
                      <FormikTextField
                        name="otp"
                        label="Enter OTP"
                        fullWidth
                        placeholder="Enter OTP Here"
                        disabled={isSubmitting}
                      />
                    </Grid2>
                  )}

                  {/* Login Button */}
                  <Grid2 size={{ xs: 12, md: 12 }}>
                    <Button
                      type="submit"
                      variant="contained"
                      size="small"
                      sx={{ width: "fit-content", py: 1 }}
                      disabled={!isOtpVisible || !values.otp || isSubmitting}
                      startIcon={
                        isSubmitting ? (
                          <CircularProgress color="inherit" size={18} />
                        ) : null
                      }
                    >
                      {isSubmitting ? "Logging in..." : "Login"}
                    </Button>
                  </Grid2>
                </Grid2>

                <Typography color="#7C7C7C">
                  Don't have an account?{" "}
                  <a
                    style={{
                      cursor: "pointer",
                      color: "royalblue",
                      textDecoration: "none",
                      display: "block",
                    }}
                  >
                    Contact&nbsp;us&nbsp;+91 89750 48440
                  </a>
                </Typography>
              </Stack>
            </Form>
          )}
        </Formik>

        {/* Footer */}
        {/* <Box
          display="flex"
          justifyContent="center"
          position="absolute"
          bottom={100}
          left="50%"
          style={{ transform: "translateX(-50%)" }}
        >
          <img
            src={makeInIndia}
            alt="Make in India Logo"
            style={{
              width: "120px",
              filter: isDark ? "invert(1)" : "none",
            }}
          />
        </Box> */}
      </Paper>
    </Box>
  );
};

export default LoginPage;
